import styled from "styled-components";

export const CenterContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
`;
